exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadImageField{display:flex;flex-direction:column}.UploadImageField label{font-size:14px;color:rgba(0,0,0,.65);font-weight:700}.UploadImageField .upload-img{background:#c8dadf;display:flex;flex-direction:column;align-items:center;justify-content:center;outline:2px dashed #92b0b3;outline-offset:-10px;padding:20px;cursor:pointer}.UploadImageField .preview-img{position:relative}.UploadImageField .preview-img .block{display:none;position:absolute;background:rgba(0,0,0,.4);align-items:center;justify-content:center;width:100%;height:100%;display:flex}.UploadImageField .preview-img .block .btn{margin:0}.UploadImageField .preview-img:hover .block{display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/helpers/Fields/UploadImageField.scss
// module id = 4561
// module chunks = 0